export default __webpack_public_path__ + "static/media/inactive-pie-chart.edf33220.svg";